export const QR_FILE_CREATE = `v2/files-qrs/create`;
export const TRANACTIONS_CREATE = `v2/transaction-requests`;
export const ORG_INFORMATION = `/v2/org-information`;
export const JOB_TITLES = `v2/selects/job-titles`;
export const TRANSACTION_TYPES = `v2/selects/transaction-types`;
export const TRANACTION_BY_ID = (id) => `/v2/transaction-requests/${id}`;
export const TRANACTION_Desc_BY_ID = (id) => `/v2/selects/transaction-types/${id}`;
export const CONSECUTIVESUBMISSION_BY_ID = (id) => `/v2/consecutive-submission/${id}`;

